import React from 'react';
import { CustomerLayout } from '../../components/layouts/CustomerLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import { User, ShieldCheck, Upload } from 'lucide-react';
import { toPersianDigits } from '../../utils/persian';
export function ProfilePage() {
  return <CustomerLayout data-id="element-689">
      <div className="space-y-6" data-id="element-690">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-691">پروفایل کاربری</h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-692">
          {/* Sidebar Info */}
          <Card className="md:col-span-1" data-id="element-693">
            <CardContent className="p-6 flex flex-col items-center text-center" data-id="element-694">
              <div className="h-24 w-24 rounded-full bg-primary/10 flex items-center justify-center text-primary text-3xl font-bold mb-4" data-id="element-695">
                ع
              </div>
              <h2 className="text-xl font-bold text-gray-900" data-id="element-696">علی احمدی</h2>
              <p className="text-gray-500 mb-4" data-id="element-697">
                {toPersianDigits('09123456789')}
              </p>
              <Badge variant="success" className="mb-6" data-id="element-698">
                احراز هویت شده
              </Badge>

              <div className="w-full space-y-2" data-id="element-699">
                <Button variant="outline" className="w-full" data-id="element-700">
                  تغییر رمز عبور
                </Button>
                <Button variant="ghost" className="w-full text-red-600 hover:text-red-700 hover:bg-red-50" data-id="element-701">
                  خروج از حساب
                </Button>
              </div>
            </CardContent>
          </Card>

          {/* Main Form */}
          <div className="md:col-span-2 space-y-6" data-id="element-702">
            <Card data-id="element-703">
              <CardHeader data-id="element-704">
                <CardTitle className="text-lg" data-id="element-705">اطلاعات هویتی</CardTitle>
              </CardHeader>
              <CardContent data-id="element-706">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-707">
                  <Input label="نام" value="علی" readOnly data-id="element-708" />
                  <Input label="نام خانوادگی" value="احمدی" readOnly data-id="element-709" />
                  <Input label="کد ملی" value={toPersianDigits('1234567890')} readOnly data-id="element-710" />
                  <Input label="تاریخ تولد" value={toPersianDigits('1370/01/01')} readOnly data-id="element-711" />
                </div>
              </CardContent>
            </Card>

            <Card data-id="element-712">
              <CardHeader data-id="element-713">
                <CardTitle className="text-lg" data-id="element-714">اطلاعات تماس و آدرس</CardTitle>
              </CardHeader>
              <CardContent data-id="element-715">
                <div className="space-y-4" data-id="element-716">
                  <Input label="شماره موبایل" value={toPersianDigits('09123456789')} readOnly data-id="element-717" />
                  <Input label="ایمیل" value="ali.ahmadi@example.com" data-id="element-718" />
                  <div className="space-y-2" data-id="element-719">
                    <label className="text-sm font-medium" data-id="element-720">آدرس پستی</label>
                    <textarea className="w-full min-h-[80px] rounded-md border border-input bg-background px-3 py-2 text-sm" defaultValue="تهران، خیابان ولیعصر، بالاتر از میدان ونک..." data-id="element-721" />
                  </div>
                  <div className="flex justify-end" data-id="element-722">
                    <Button data-id="element-723">ذخیره تغییرات</Button>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card data-id="element-724">
              <CardHeader data-id="element-725">
                <CardTitle className="text-lg" data-id="element-726">مدارک هویتی</CardTitle>
              </CardHeader>
              <CardContent data-id="element-727">
                <div className="space-y-4" data-id="element-728">
                  <div className="flex items-center justify-between p-4 border rounded-lg bg-gray-50" data-id="element-729">
                    <div className="flex items-center gap-3" data-id="element-730">
                      <ShieldCheck className="h-5 w-5 text-green-600" data-id="element-731" />
                      <span className="font-medium text-sm" data-id="element-732">
                        کارت ملی (تایید شده)
                      </span>
                    </div>
                    <Button variant="ghost" size="sm" disabled data-id="element-733">
                      مشاهده
                    </Button>
                  </div>

                  <div className="flex items-center justify-between p-4 border rounded-lg border-dashed" data-id="element-734">
                    <div className="flex items-center gap-3" data-id="element-735">
                      <Upload className="h-5 w-5 text-gray-400" data-id="element-736" />
                      <span className="font-medium text-sm text-gray-600" data-id="element-737">
                        شناسنامه (بارگذاری نشده)
                      </span>
                    </div>
                    <Button variant="outline" size="sm" data-id="element-738">
                      آپلود
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </CustomerLayout>;
}